import React  from 'react';
import "./Groups.css";

const Groups = React.memo(props => {
    return (
        <div className="GroupWrap">
            <div className="groupImg">
                <img className="img-fluid groupImgDisplay" src={props.item.MODFocusImage.ImageUrl} data-holder-rendered="true"  alt={"תמונות קבוצה " + props.item.Title}/>
            </div>
            <div className="GroupDetails">
                <h3 className="siteText" alt={props.item.Title}>{props.item.Title}</h3>
                <div className="GroupInnerText" dangerouslySetInnerHTML={{__html: props.item.MODFocusMainText}}></div>
            </div>
            <div className="GrouplinkWrap"> 
                    <a href={props.item.ModPageLink_Url} title={props.linkTitle}> 
                        <span> {props.linkTitle} </span>
                       </a>
                </div>
        </div>
    );
});
    export default Groups;